import * as React from 'react';
import { Button } from '@cian/ui-kit';

import { useCallbackButton } from './useCallbackButton';
import { TRequestCallbackOpener } from '../../types/microfrontends/newbuildingCallbackWidget';

interface ISecondaryCallbackButtonProps {
  placeType: TRequestCallbackOpener;
}

export function SecondaryCallbackButton({ placeType }: ISecondaryCallbackButtonProps) {
  const [isAvailable, handleClick, isLoading] = useCallbackButton(placeType);

  if (!isAvailable) {
    return null;
  }

  return (
    <Button
      theme="fill_secondary"
      size={'M'}
      onClick={handleClick}
      fullWidth
      loading={isLoading}
      data-testid="SecondaryCallbackButton"
    >
      Заказ звонка
    </Button>
  );
}
